<template>
  <div class="col-12 col-md-6 col-lg-4 p-3">
    <img :src="portada" class="mw-100" alt="Foto de promoción">
    <h3 class=" mt-2 p-2">{{nombre}}</h3>
    <p class=" mt-2 p-2">
      {{descripcion}}
    </p>
  </div>
</template>

<script>
export default {
  name: 'Promotion',
  props: {
    descripcion: String,
    engancheSugerido: Number,
    idFinanciamiento: Number,
    idVehiculo: Number,
    nombre: String,
    portada: String
  }
}
</script>

<style scoped>

</style>
